import { combineReducers } from 'redux';

import stickyISI from './sticky-isi';

export default combineReducers({
	stickyISI,
});
